import { zodResolver } from "@hookform/resolvers/zod";
import type { ComponentProps } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import z from "zod";
import { enqueueSnackbar } from "../../../../../components/GlobalSnackbar/snackbarStore";
import { isSupabaseError } from "../../../../../constants/supabaseErrors";
import type AddReminderActionModal from "./AddReminderActionModal";
import useSubjectActionModal from "../useSubjectActionModal";
import { formSchema as formSchemaBase } from "../types";

const formSchema = formSchemaBase.extend({
  date: z.date('Ce champ est obligatoire').transform(val => val.toISOString()),
  contact_name: z.string().trim().min(1, "Ce champ est obligatoire"),
  provider_name: z.string().trim().min(1, "Ce champ est obligatoire"),
});

type FormInputs = z.input<typeof formSchema>;
type FormValues = z.infer<typeof formSchema>;

type Props = ComponentProps<typeof AddReminderActionModal>;

export default function useAddReminderActionModal(props: Props) {
  const [serverError, setServerError] = useState<string | null>(null);

  const form = useForm<FormInputs, unknown, FormValues>({
    mode: "onChange",
    defaultValues: {
      date: props.item?.date ? new Date(props.item.date) : new Date(),
      contact_name: props.item?.contact_name || "",
      provider_name: props.item?.provider_name || "",
      comment: props.item?.comment || "",
      documents: [],
    },
    resolver: zodResolver(formSchema),
  });

  const {
    isDocumentLoading,
    isLoading,
    handleCallApi,
  } = useSubjectActionModal(
    "reminder",
    props.item?.id ?? undefined,
    props.subjectId,
    form,
  );

  async function handleConfirm(data: FormValues) {
    setServerError(null);

    try {
      await handleCallApi(data);

      enqueueSnackbar(props.item ? "Relance mise à jour." : "Relance enregistrée.", "success");
      props.onClose();
    } catch (error: unknown) {
      if (isSupabaseError(error)) {
        setServerError(error.message);
        return;
      }

      setServerError(
        "Une erreur est survenue",
      );
    }
  }

  return {
    form,
    handleConfirm,
    isLoading,
    serverError,
    isDocumentLoading,
  };
}
